"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invalidTokenError = exports.buildErrorResponse = void 0;
var buildErrorResponse = function (error, errorDescription) {
    return {
        error: error,
        errorDescription: errorDescription,
    };
};
exports.buildErrorResponse = buildErrorResponse;
var invalidTokenError = function (description) { return (0, exports.buildErrorResponse)('invalid_token', description); };
exports.invalidTokenError = invalidTokenError;
